module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_9_4.ad7646e5.png";